import React from 'react';
import DropOffLocationsDisplay from '../drop-off-locations-display/drop-off-locations-display';

export default function DropoffLocationsList({ dropoffLocations }) {
  return dropoffLocations?.slice(0, 2)?.map(
    (location, idx) => (
      <DropOffLocationsDisplay location={location} idx={idx} key={location.id} />
    ),
  );
}
